<template>
	<div class="cetin-products-component text-left container-fluid"  >
		<div v-if="finalNutnosti && finalNutnosti.length > 0 && finalAttributy && finalAttributy.length > 0" class="nutnosti "> 
            <div class="nutnosti-title"> Cetin: </div>
            <div v-if="finalNutnosti.length" v-for="x of finalNutnosti" class="nutnosti-row" :key="x">
            {{ x }} - {{ translateNutnosti[x] }}
            </div>
            <div v-if="finalAttributy.length" v-for="x of finalAttributy" class="nutnosti-row" :key="x" >
            {{ x }} {{ x === 'Metalická' ? '' : 'Mbps' }}
            </div>
            <div v-if="cetinToBeAvailable.length">
                <button @click="showToBeReadyFn"> Připravované </button>
                <div v-if="showToBeReady && cetinToBeAvailable.length">
                    <div v-for="(y, index) of cetinToBeAvailable" :key="index">
                        {{ y.rychlost }}Mbps - {{ y.kdy.split(' ')[0] }} {{ y.kdy.split(' ')[1] === 'months' ? 'měsice' : y.kdy.split(' ')[1]}}
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
export default {
	name: 'AddressCetinInfo',
    
    props: {
		finalNutnosti: Array,
		finalAttributy: Array,
		created: Boolean,
		isBonding: Boolean,
		cetinToBeAvailable: Array,
    },

	data () {
		return {
			translateNutnosti: {
                '10': 'OK',
                '20': 'Nějaké problémy',
                '30': 'S problémy',
                '40': 'S problémy',
                '50': 'Nelze',
			},
			
            showToBeReady: false,
		}
    },

	methods: {
		showToBeReadyFn () {
            this.showToBeReady = ! this.showToBeReady
        },
	},
}
</script>

<style lang="stylus" scoped>
.cetin-products-component
	display flex
	flex-direction column

.cetin-products 
	margin-top 15px

.cetin-title 
	font-size 28px
	color gray
	text-align left

.nutnosti
	margin-top 20px
	display flex
	flex-direction column

.nutnosti-title
	font-size 24px
	color: gray

.cetin-max-speed 
	text-align left
	display flex
	flex-direction row
	background-color white
	padding 3px
	margin-top 5px

</style>



// WEBPACK FOOTER //
// src/components/verifier/AddressCetinInfo.vue